import { layout } from '~/tools/layout';
import { commonTypography } from './shared/typography';

/**
 * All app typography settings.
 *
 * These definitions relate to built-in MUI targets, but can also be referenced
 * directly in custom contexts. Use one of these settings to maintain consistency.
 * If you need a special customization, perhaps think about defining a new entry
 * to this object (e.g., see "tab" as an example custom typography setting).
 *
 * @see https://mui.com/material-ui/customization/typography/
 * @see https://mui.com/material-ui/react-css-baseline/
 * @see https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override
 */
export const typography = {
  htmlFontSize: commonTypography.htmlFontSize,
  fontSize: commonTypography.fontSize,
  fontFamily: commonTypography.fontFamily,

  // Titles + Headings
  h1: {
    fontFamily: commonTypography.fontFamily,
    fontSize: layout.pxToRem(24),
    fontWeight: 400,
    letterSpacing: '-0.01562em',
    lineHeight: 1.25,
  },
  h2: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '2rem',
    fontWeight: 400,
    letterSpacing: '-0.01562em',
    lineHeight: 1.25,
  },
  h3: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1.75rem',
    fontWeight: 400,
  },
  h4: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1.5rem',
    fontWeight: 400,
    letterSpacing: '0.0075em',
    lineHeight: 1.6,
  },
  h5: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1.25rem',
    fontWeight: 400,
  },
  h6: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1rem',
    fontWeight: 300,
  },
  subtitle1: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1rem',
  },
  subtitle2: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '0.875rem',
  },

  // Regular text
  body1: {
    fontFamily: commonTypography.fontFamily,
    fontSize: layout.pxToRem(14),
    letterSpacing: '0.00938em',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: commonTypography.fontFamily,
    fontSize: layout.pxToRem(14),
    letterSpacing: '0.01071em',
    lineHeight: 1.43,
  },

  // Special elements
  button: {
    fontFamily: commonTypography.fontFamily,
    fontSize: layout.pxToRem(16),
    fontWeight: 400,
    letterSpacing: '0.02857em',
    lineHeight: 1.75,
    textTransform: 'capitalize',
  },
  caption: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: '0.03333em',
    lineHeight: 1.66,
  },
  overline: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '0.75rem',
    fontWeight: 400,
    letterSpacing: '0.083333em',
    lineHeight: 2.66,
    textTransform: 'uppercase',
  },
  tab: {
    fontFamily: commonTypography.fontFamily,
    fontSize: '1rem',
    fontWeight: 500,
    letterSpacing: '0.39998px',
    lineHeight: 1.5,
  },
};
